module.exports = __webpack_public_path__ + "static/img/boloni.8887b86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/boloni.jpg
// module id = GXDO
// module chunks = 1